import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        header: '<',
        body: '<'
    },
    template: `
    <div class="modal-header">
        <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
        <h2>{{ vm.header }}</h2>
    </div>
    <div class="modal-body">
        <p>{{ vm.body }}</p>
    </div>
    <div class="modal-footer">
        <ul class="actions01">
            <li class="primary">
                <button class="btn main" type="button" ng-click="vm.uibModalInstance.dismiss()">
                    {{ 'general.Ok' | translate }}
                </button>
            </li>
        </ul>
    </div>
    `
})
export default class {}



// WEBPACK FOOTER //
// ./src/app/components/modals/filterOverview/index.js